const flowChartData = {
    "management": {
        "title": "Management",
        "type": "questionnaire",
        "content": [],
        "flows": []
    },
    "management_pain": {
        "title": "Pain management",
        "type": "questionnaire",
        "pages": [
            {
                "visible": "true",
                "content": [
                    {
                        "visible": "true",
                        "text": "What is the patient's current medication?",
                        "id": "medication",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Buprenorphine"
                            },
                            {
                                "text": "Naltrexone"
                            }
                        ]
                    },
                    {
                        "visible": "medication === 'Buprenorphine' || medication === 'Naltrexone'",
                        "text": "Is pain chronic or acute?",
                        "id": "pain_type",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Chronic"
                            },
                            {
                                "text": "Acute"
                            }
                        ]
                    },
                    {
                        "visible": "medication === 'Naltrexone' && pain_type === 'Acute'",
                        "text": "Was pain anticipated?",
                        "id": "naltrexone_pain_anticipated",
                        "type": "yesno"
                    }
                ]
            }
        ],
        "flows": [
            {
                "value": "medication === 'Buprenorphine' && pain_type !== ''",
                "algorithm": "buprenorphine_pain"
            },
            {
                "value": "medication === 'Naltrexone' && pain_type === 'Chronic'",
                "algorithm": "naltrexone_chronic_pain"
            },
            {
                "value": "medication === 'Naltrexone' && pain_type === 'Acute' && naltrexone_pain_anticipated === true",
                "algorithm": "naltrexone_pain_anticipated"
            },
            {
                "value": "medication === 'Naltrexone' && pain_type === 'Acute' && naltrexone_pain_anticipated === false",
                "algorithm": "naltrexone_pain_unanticipated"
            }
        ]
    },
    "management_initiation": {
        "title": "Initiation",
        "type": "questionnaire",
        "pages": [
            {
                "visible": "true",
                "content": [
                    {
                        "visible": "true",
                        "text": "Which medication are you initiating?",
                        "id": "medication",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Buprenorphine"
                            },
                            {
                                "text": "Naltrexone"
                            },
                            {
                                "text": "Unsure"
                            }
                        ]
                    },
                    {
                        "visible": "medication === 'Buprenorphine'",
                        "text": "Which form of buprenorphine?",
                        "id": "b_medication",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Transmucosal buprenorphine"
                            },
                            {
                                "text": "Injectable buprenorphine"
                            },
                            {
                                "text": "Transition from methadone"
                            }
                        ]
                    }
                ]
            },
            {
                "visible": "medication === 'Buprenorphine' && b_medication === 'Transmucosal buprenorphine'",
                "content": [
                    {
                        "visible": "true",
                        "id": "diagnosed_boud",
                        "text": "Does your patient meet the DSM-5 criteria for an opioid use disorder?",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Yes"
                            },
                            {
                                "text": "No"
                            },
                            {
                                "text": "I don't know",
                                "tool": "dsm_oud"
                            }
                        ]
                    },
                    {
                        "visible": "diagnosed_boud_v === true && diagnosed_boud === \"I don't know\"",
                        "id": "dsm_oud",
                        "type": "section"
                    },
                    {
                        "visible": "diagnosed_boud === 'Yes'",
                        "id": "boud",
                        "text": "Is your patient currently opioid dependent?",
                        "type": "yesno"
                    },
                    {
                        "visible": "boud_v === true && boud === true",
                        "id": "boud_withdrawal",
                        "text": "Is your patient currently in active opioid withdrawal?",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Yes, in active opioid withdrawal"
                            },
                            {
                                "text": "No, not yet in opioid withdrawal"
                            }
                        ]
                    }
                ]
            },
            {
                "visible": "medication === 'Buprenorphine' && b_medication === 'Injectable buprenorphine'",
                "content": [
                    {
                        "visible": "true",
                        "id": "boud_tolerate_bupe_8mg",
                        "text": "Does patient have an OUD and known to tolerate \u2265 8mg of prescribed transmucosal buprenorphine?",
                        "type": "yesno"
                    },
                    {
                        "visible": "boud_tolerate_bupe_8mg === true",
                        "id": "inj_bupe_planning",
                        "text": "Where are you in the planning process?",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Obtaining medication"
                            },
                            {
                                "text": "Preparing for injection day"
                            },
                            {
                                "text": "Injection day"
                            }
                        ]
                    }
                ]
            },
            {
                "visible": "medication === 'Naltrexone'",
                "content": [
                    {
                        "visible": "true",
                        "id": "diagnosed_noud",
                        "text": "Does your patient meet the DSM-5 criteria for an opioid use disorder?",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Yes"
                            },
                            {
                                "text": "No"
                            },
                            {
                                "text": "I don't know",
                                "tool": "dsm_oud"
                            }
                        ]
                    },
                    {
                        "visible": "true",
                        "id": "diagnosed_aud",
                        "text": "Does your patient have a confirmed diagnosis of AUD?",
                        "type": "choice",
                        "choices": [
                            {
                                "text": "Yes"
                            },
                            {
                                "text": "No"
                            },
                            {
                                "text": "I don't know",
                                "tool": "audit_c"
                            }
                        ]
                    },
                    {
                        "visible": "diagnosed_noud_v === true && diagnosed_noud === \"I don't know\"",
                        "id": "dsm_oud",
                        "type": "section"
                    },
                    {
                        "visible": "diagnosed_aud_v === true && diagnosed_aud === \"I don't know\"",
                        "id": "audit_c",
                        "type": "section"
                    }
                ]
            },
            {
                "visible": "medication === 'Naltrexone' && diagnosed_noud === 'Yes'",
                "content": [
                    {
                        "visible": "true",
                        "id": "oud_last_use_gt710days",
                        "text": "Was last opioid use &gt;7-10 days ago? <b>and</b> Toxicology screen negative for opioids?",
                        "type": "yesno"
                    },
                    {
                        "visible": "oud_last_use_gt710days === true",
                        "id": "oud_lfts_5x",
                        "text": "Does patient have LFTs >5x the upper limit of normal?",
                        "type": "yesno"
                    }
                ]
            },
            {
                "visible": "medication === 'Naltrexone' && (diagnosed_noud === 'No' && diagnosed_aud === 'Yes')",
                "content": [
                    {
                        "visible": "true",
                        "id": "aud_lfts_5x",
                        "text": "Does patient have LFTs >5x the upper limit of normal?",
                        "type": "yesno"
                    }
                ]
            },
            {
                "visible": "medication === 'Buprenorphine' && b_medication === 'Transmucosal buprenorphine' && diagnosed_boud === 'No'",
                "content": [
                    {
                        "visible": "true",
                        "text": [
                            "<b>Your patient is not a candidate for buprenorphine at this time.</b>"
                        ]
                    }
                ]
            },
            {
                "visible": "medication === 'Naltrexone' && diagnosed_noud === 'No' && diagnosed_aud === 'No'",
                "content": [
                    {
                        "visible": "true",
                        "text": [
                            "<b>Your patient is not a candidate for naltrexone at this time.</b>"
                        ]
                    }
                ]
            },
            {
                "visible": "medication === 'Unsure'",
                "content": [
                    {
                        "visible": "true",
                        "text": [
                            "When recommending MAT for patients who have OUD, there are some considerations including, but not limited to:",
                            "",
                            " \u2022 Is the patient currently opioid dependent?",
                            " \u2022 Does the patient have a history of overdose?",
                            " \u2022 Does the patient prefer buprenorphine over naltrexone?",
                            "",
                            "If the answer to any of these questions are yes, then buprenorphine may be the preferred option.",
                            "",
                            "Buprenorphine is a partial opioid agonist, and along with methadone, is considered first-line treatment for opioid use disorder. Buprenorphine can block the effects of other opioids, and reduce opioid withdrawal symptoms and cravings. Buprenorphine, with its high affinity to the mu-opioid receptor, blocks the effects of other opioids and is therefore protective against fatal overdose. Buprenorphine can be initiated within 24 hrs of most recent use (exception is if patient is transferring from methadone in which more time and planning is required). It is available in tablet, film and long-acting injectable formulations.",
                            "",
                            "If your patient is being treated with buprenorphine and also has an alcohol use disorder, acamprosate or disulfiram are medications that may be co-prescribed with buprenorphine. Peer support, psychotherapy, and medical management are also proven beneficial adjuncts to medication treatment.",
                            "",
                            "Naltrexone is a potent opioid antagonist that works by blocking the effects of opioids on the mu-receptor. It is available in tablet and long-acting injectable formulations.  Patients initiating naltrexone treatment must be fully withdrawn from opioids (typically defined as 7 or more days without use of any opioid) to avoid a potentially severe withdrawal syndrome.",
                            "",
                            "Naltrexone is also a first-line treatment for alcohol use disorder. It is thought to reduce the reward associated with drinking by blocking the dopaminergic endorphins (which act on the mu opioid receptors) released following alcohol consumption in addition to reducing cravings for alcohol."
                        ]
                    },
                    {
                        "style": "plain",
                        "visible": "true",
                        "text": [
                            "<small>References:<br>Lee JD, Nunes EV Jr, Novo P, et al. Comparative effectiveness of extended-release naltrexone versus buprenorphine-naloxone for opioid relapse prevention (X:BOT): a multicentre, open-label, randomised controlled trial. Lancet. <a href='https://www.sciencedirect.com/science/article/pii/S014067361732812X?via%3Dihub'>https://www.sciencedirect.com/science/article/pii/S014067361732812X?via%3Dihub</a><br>Wakeman SE, Larochelle MR, Ameli O, et al. Comparative Effectiveness of Different Treatment Pathways for Opioid Use Disorder. JAMA Netw Open. <a href ='https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2760032'>https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2760032</a></small>"
                        ]
                    }
                ]
            },
            {
                "visible": "medication === 'Buprenorphine' && b_medication === 'Transition from methadone'",
                "content": [
                    {
                        "visible": "true",
                        "text": [
                            "The transitional period from methadone to buprenorphine is challenging due to physical discomfort experienced by the patient, requirement for close monitoring and support by outpatient care teams, and close collaboration with the patient’s opioid treatment program (OTP) care team. Transitions should ideally be thoughtfully planned with close monitoring of patients to ensure both comfort and safety. With a planned methadone to buprenorphine transition, the general recommendation is to slowly taper the daily dose of methadone to 30 mg or less (example – decreasing 2-5 mg weekly depending on OTP protocols) prior to initiating buprenorphine to minimize the risk for occurrence of precipitated withdrawal. As the patient is tapered to subtherapeutic doses of methadone, it is important to note that opioid tolerance is reduced, cravings may be enhanced, and the opioid-blocking protection from overdose has decreased. Thus, patients should be counseled about the risk for recurrence of use and subsequent overdose and offered additional supports during this period of time.",
                            "",
                            "It is highly recommended to sign 42 CFR Part 2 release in order to collaborate with the patient’s OTP care team prior to beginning the process to transfer to buprenorphine, as close communication with the patient and their OTP team is essential to coordinate successful transitions of care. Confirm with OTP team that if the patient is unable to transition to buprenorphine (e.g. withdrawal symptoms are interfering with functioning or buprenorphine is not tolerated) that a reconnection back to methadone within the OTP is possible without gaps in treatment.",
                            "",
                            "Given the complexity and challenges, we recommend patient admission for medically supervised withdrawal and transitional support or close collaboration with an experienced addiction provider when conducted on an outpatient basis, especially for patients who attempt transfer from methadone at doses higher than 40 mg. To connect with a national network of trained clinicians and receive free mentoring and clinical advice visit <a href='http://www.pcssnow.org/mentoring' style='text-decoration:none;'>pcssnow.org/mentoring</a>.",
                            "",
                            "Information on the process of transition from methadone to other medications for the treatment of opioid use disorder can be found in the American Society for Addiction Medicine National Practice Guidelines <a href='https://sitefinitystorage.blob.core.windows.net/sitefinity-production-blobs/docs/default-source/guidelines/npg-jam-supplement.pdf?sfvrsn=a00a52c2_2#page=41' style='text-decoration:none;'>&#9432</a>."
                        ]
                    }
                ]
            }
        ],
        "flows": [
            {
                "value": "medication === 'Buprenorphine' && b_medication === 'Transmucosal buprenorphine' && boud !== '' && diagnosed_boud == 'Yes' && (boud === false || boud_withdrawal !== '')",
                "algorithm": "buprenorphine_initiation_oud"
            },
            {
                "value": "medication === 'Buprenorphine' && b_medication === 'Injectable buprenorphine' && boud_tolerate_bupe_8mg === true && inj_bupe_planning === 'Obtaining medication'",
                "algorithm": "inj_buprenorphine_initiation_ready"
            },
            {
                "value": "medication === 'Buprenorphine' && b_medication === 'Injectable buprenorphine' && boud_tolerate_bupe_8mg === true && inj_bupe_planning === 'Preparing for injection day'",
                "algorithm": "inj_buprenorphine_initiation_checklist"
            },
            {
                "value": "medication === 'Buprenorphine' && b_medication === 'Injectable buprenorphine' && boud_tolerate_bupe_8mg === true && inj_bupe_planning === 'Injection day'",
                "algorithm": "inj_buprenorphine_initiation_inj_day"
            },
            {
                "value": "medication === 'Buprenorphine' && b_medication === 'Injectable buprenorphine' && boud_tolerate_bupe_8mg === false",
                "algorithm": "buprenorphine_initiation_not"
            },
            {
                "value": "medication === 'Naltrexone' && diagnosed_noud === 'No' && diagnosed_aud === 'Yes' && aud_lfts_5x === true",
                "algorithm": "naltrexone_initiation_aud_etiology"
            },
            {
                "value": "medication === 'Naltrexone' && diagnosed_noud === 'No' && diagnosed_aud === 'Yes' && aud_lfts_5x === false",
                "algorithm": "naltrexone_initiation_aud"
            },
            {
                "value": "medication === 'Naltrexone' && diagnosed_noud === 'Yes' && diagnosed_aud !== \"I don't know\" && oud_last_use_gt710days === false",
                "algorithm": "naltrexone_initiation_oud"
            },
            {
                "value": "medication === 'Naltrexone' && diagnosed_aud !== \"I don't know\" && oud_last_use_gt710days === true && oud_lfts_5x !== ''",
                "algorithm": "naltrexone_initiation_oud"
            }
        ]
    },
    "buprenorphine_initiation_not": {
        "title": "Initiation of Monthly Injectable Buprenorphine",
        "tool": "QSG_2022",
        "content": [
            {
                "visible": "true",
                "text": [
                    "<b>Your patient is not a candidate at this time.</b>",
                    "Candidates for injectable buprenorphine are those who have initiated treatment with a transmucosal buprenorphine containing product of at least 8 mg for a minimum of 7 days. If your patient has not yet initiated transmucosal buprenorphine, please refer to the guidelines for initiation of transmucosal buprenorphine."
                ]
            }
        ]
    },
    "buprenorphine_initiation_oud": {
        "title": "Buprenorphine Quick Start",
        "type": "care_plan",
        "tool": "QSG_2022",
        "content": [
            {
                "visible": "boud === false",
                "style": "dark",
                "text": [
                    "<b>Not currently dependent</b>"
                ]
            },
            {
                "visible": "boud === true && boud_withdrawal && boud_withdrawal.startsWith('No')",
                "style": "dark",
                "text": [
                    "<b>High risk for precipitated withdrawal</b>"
                ]
            },
            {
                "visible": "boud === true && boud_withdrawal && boud_withdrawal.startsWith('Yes')",
                "style": "dark",
                "text": [
                    "<b>In active opioid withdrawal</b>"
                ]
            },
            {
                "visible": "true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "boud === false",
                "style": "pink",
                "text": [
                    "\u2022 Start Low and Go Slow!",
                    "\u2022 Typical day 1 dosing: 2 mg total daily dose",
                    "\u2022 Slow titration (+2 mg every 3-5 days) to achieve opioid  blockade and/or elimination of cravings"
                ]
            },
            {
                "visible": "boud === true && boud_withdrawal && boud_withdrawal.startsWith('No')",
                "style": "pink",
                "text": [
                    "\u2022 Office initiation recommended.",
                    "\u2022 COWS score to help direct initiation and assure patient is in moderate withdrawal.",
                    "\u2022 Day 1: 2-4 mg of buprenorphine. Re-dose every 2-4 hours as withdrawal subsides and reappears.",
                    "\u2022 Review handout for instructions on additional unobserved dosing.",
                    "\u2022 Typical Day 1 dosing: 16-24 mg"
                ]
            },
            {
                "visible": "boud === true && boud_withdrawal && boud_withdrawal.startsWith('Yes')",
                "style": "pink",
                "text": [
                    "\u2022 COWS score to help guide initiation and to ensure patient in moderate withdrawal.",
                    "\u2022 For persons using fentanyl, recommend last use be at least 24 hrs prior to starting buprenorphine to avoid precipitated withdrawal.",
                    "\u2022 Provide anticipatory guidance and medications* for withdrawal management",
                    "\u2022 Typical Day 1 dosing: 2-4mg every 2 hrs, up to max dose of 24mg on day 1.",
                    "\u2022 If unobserved initiation, review handout."
                ]
            },
            {
                "visible": "true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "true",
                "style": "gray",
                "text": [
                    "\u2192 Maintenance dose should be individualized to achieve opioid blockade and/or elimination of cravings",
                    "\u2192 Typical maintenance dose: 8-24 mg daily"
                ]
            },
            {
                "visible": "true",
                "id": "cows_tool",
                "text": "COWS Tool",
                "figure": "cows_tool",
                "type": "button"
            },
            {
                "visible": "true",
                "id": "boud_handout",
                "text": "Review Patient Handout (English)",
                "figure": "handout_english",
                "type": "button"
            },
            {
                "visible": "true",
                "id": "boud_handout",
                "text": "Review Patient Handout (Spanish)",
                "figure": "handout_spanish",
                "type": "button"
            }
        ]
    },
    "inj_buprenorphine_initiation_ready": {
        "title": "Initiation of Monthly Injectable Buprenorphine",
        "type": "care_plan",
        "tool": "Initiation of Monthly Injectionable Buprenorphine  SLIDE 08-22_FINAL",
        "content": [
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "<b>Obtaining medication:</b>",
                    "\u2022 Start prior authorization process for injectable buprenorphine.",
                    "\u2022 Order from REMS pharmacy source. <a href='https://www.addictiontraining.org/REMS' style='text-decoration:none;'>&#9432</a>",
                    "\u2022 Follow REMS and controlled substance protocols for storage and handling."
                ]
            },
            {
                "visible": "in1 !== true",
                "id": "in1",
                "text": "Next",
                "type": "vbutton"
            },
            {
                "visible": "in1 === true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "in1 === true",
                "style": "pink",
                "text": [
                    "<b>Preparing for injection day:</b>",
                    "\u2022 Advise patient not to take transmucosal dose day of injection.",
                    "\u2022 Inform patient the color of medicine may vary from clear, yellow, or amber.",
                    "\u2022 Collect toxicology screen.",
                    "\u2022 Obtain consent for treatment. <a href='https://www.addictiontraining.org/consent' style='text-decoration:none;'>&#9432</a>",
                    "",
                    "Review with patient the injection procedure and potential for injection site reaction."
                ]
            },
            {
                "visible": "in1 === true && in2 !== true",
                "id": "in2",
                "text": "Next",
                "type": "vbutton"
            },
            {
                "visible": "in1 === true && in2 === true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "in1 === true && in2 === true",
                "style": "pink",
                "text": [
                    "<b>Injection day:</b>",
                    "Administer SQ injection per package insert instructions. <a href='https://www.addictiontraining.org/injection' style='text-decoration:none;'>&#9432</a>",
                    "",
                    "Informed consent required prior to initial injection only."
                ]
            }
        ],
        "flows": []
    },
    "inj_buprenorphine_initiation_checklist": {
        "title": "Initiation of Monthly Injectable Buprenorphine",
        "type": "care_plan",
        "tool": "Initiation of Monthly Injectionable Buprenorphine  SLIDE 08-22_FINAL",
        "content": [
            {
                    "visible": "true",
                    "style": "pink",
                    "text": [
                        "<b>Preparing for injection day:</b>",
                        "\u2022 Advise patient not to take transmucosal dose day of injection.",
                        "\u2022 Inform patient the color of medicine may vary from clear, yellow, or amber.",
                        "\u2022 Collect toxicology screen.",
                        "\u2022 Obtain consent for treatment. <a href='https://www.addictiontraining.org/consent' style='text-decoration:none;'>&#9432</a>",
                        "",
                        "Review with patient the injection procedure and potential for injection site reaction."
                    ]
                },
                {
                    "visible": "in2 !== true",
                    "id": "in2",
                    "text": "Next",
                    "type": "vbutton"
                },
                {
                    "visible": "in2 === true",
                    "style": "down_arrow",
                    "text": []
                },
                {
                    "visible": "in2 === true",
                    "style": "pink",
                    "text": [
                        "<b>Injection day:</b>",
                        "Administer SQ injection per package insert instructions. <a href='https://www.addictiontraining.org/injection' style='text-decoration:none;'>&#9432</a>",
                        "",
                        "Informed consent required prior to initial injection only."
                    ]
                }
        ],
        "flows": []
    },
    "inj_buprenorphine_initiation_inj_day": {
        "title": "Initiation of Monthly Injectable Buprenorphine",
        "type": "care_plan",
        "tool": "Initiation of Monthly Injectionable Buprenorphine  SLIDE 08-22_FINAL",
        "content": [
            {
                "visible": "true",
                "text": [
                    "<b>Injection day:</b>",
                    "Administer SQ injection per package insert instructions. <a href='https://www.addictiontraining.org/injection' style='text-decoration:none;'>&#9432</a>",
                    "",
                    "Informed consent required prior to initial injection only."
                ]
            }
        ]
    },
    "naltrexone_initiation_aud_etiology": {
        "title": "Naltrexone Initiation for Alcohol Use Disorder",
        "type": "care_plan",
        "tool": "Naltrexone Initiation for Alcohol Use Disorder SLIDE 09-22_ FINAL",
        "content": [
            {
                "visible": "true",
                "text": [
                    "Evaluate etiology and determine if patient is appropiate for naltrexone.",
                    "\u2022 To seek free, confidential clinician-to-clinician consultation contact the <a href='https://nccc.ucsf.edu/clinical-resources/substance-use-resources/'>Substance Use Warmline.</a>"
                ]
            }
        ]
    },
    "naltrexone_initiation_aud": {
        "title": "Naltrexone Initiation for Alcohol Use Disorder",
        "type": "care_plan",
        "tool": "Naltrexone Initiation for Alcohol Use Disorder SLIDE 09-22_ FINAL",
        "content": [
            {
                "visible": "true",
                "text": [
                    "Oral and injectable naltrexone are FDA approved for AUD however the injectable fromulation is preferred due to improved adherence with limited side effects.",
                    "",
                    "<b>For oral naltrexone:</b> Consider initiating at 25mg daily for up to 1 week to minimize GI side effects before increasing to a maintenance dose of 50mg daily.",
                    "",
                    "<b>For injectable naltrexone:</b> Initiate process for ordering extended-release naltrexone following <b>REMS</b> guidance.",
                    " \u2022 Consider short trial of oral naltrexone prior to inject to ensure no adverse effects of precipitated withdrawal.",
                    " \u2022 <b>Injection day:</b> If there is a concern patient may have recently used opioids, obtain drug urine screen and/or naltrexone challenge to avoid precipitated withdrawal.",
                    " \u2022 Provide emergency alert identification. Administer IM injection per package insert.",
                    "  \u2022 Weekly check-ins recommemnded initially; decrease frequency with stabilization."
                ]
            }
        ]
    },
    "naltrexone_initiation_oud": {
        "title": "Naltrexone Initiation for Opioid Use Disorder",
        "type": "care_plan",
        "tool": "naltrexone-initiation-for-opioid-use-disorder 09-22_FINAL",
        "content": [
            {
                "visible": "diagnosed_aud == 'No' && oud_last_use_gt710days === false",
                "text": [
                    "Must fully withdraw from opioids for 7-10 days before starting naltrexone to avoid precipitated withdrawal.",
                    "",
                    "<b>During withdrawal period:</b>",
                    " \u2022 Ensure access to naloxone/narcan.",
                    " \u2022 Consider medications for withdrawal management.",
                    " \u2022 Closely monitor and support.",
                    "For severe withdrawal symptoms or high risk for reccurent use, consider inpatient setting to decrease the risk for overdose during medication initiation or consider agonist therapy using buprenorphine or methadone*.",
                    "*Methadone can only be administered through an Opioid Treatment Program."

                ]
            },
            {
                "visible": "diagnosed_aud === 'Yes' && oud_last_use_gt710days === false",
                "text": [
                    " \u2022 Must fully withdraw from opioids for 7-10 days before starting naltrexone to avoid precipitated withdrawal.",
                    " \u2022 Consider other treatment options to manage co-occurring alcohol use disorder.",
                    "",
                    "<b>During withdrawal period:</b>",
                    " \u2022 Ensure access to naloxone/narcan.",
                    " \u2022 Consider medications for withdrawal management.",
                    " \u2022 Closely monitor and support.",
                    "For severe withdrawal symptoms or high risk for reccurent use, consider inpatient setting to decrease the risk for overdose during medication initiation or consider agonist therapy using buprenorphine or methadone*.",
                    "*Methadone can only be administered through an Opioid Treatment Program."
                ]
            },
            {
                "visible": "oud_lfts_5x_v == true && oud_lfts_5x === true",
                "text": [
                    "Evaluate etiology and determine if patient is appropiate for naltrexone.",
                    "\u2022 To seek free, confidential clinician-to-clinician consultation contact the <a href='https://nccc.ucsf.edu/clinical-resources/substance-use-resources/'>Substance Use Warmline.</a>"
                ]
            },
            {
                "visible": "oud_lfts_5x_v == true && oud_lfts_5x === false",
                "text": [
                    "Initiate process for ordering naltrexone extended-release following <b><u>REMS guidance.</u></b>",
                    "\u2022 Consider short trial of oral naltrexone prior to injection to enure no adverse effects or precipitated withdrawal.",
                    "\u2022 Injection day: obtain rapid urine screen and/or naltrexone challenge to avoid precipitated withdrawal.",
                    "\u2022 Provide emergency alert identification.",
                    "\u2022 Administer IM per package insert instructions",
                    "\u2192 Weekly check in recommended initially; decrease frequency with stabilization."
                ]
            },
            {
                "visible": "oud_last_use_gt710days === false",
                "id": "med_button",
                "text": "Medications",
                "figure": "medications_assist",
                "type": "button"
            }
        ]
    },
    "naltrexone_chronic_pain": {
        "title": "Pain Management While on Naltrexone",
        "type": "care_plan",
        "tool": "Pain Management While on Naltrexone for Opioid Use Disorder 1-25-2023",
        "content": [
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "Establish goals of pain reduction and improved function with patient."
                ]
            },
            {
                "visible": "true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "Start with non-opioid medications and adjuvant therapies."
                ]
            },
            {
                "visible": "true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "true",
                "text": "Is pain improved?",
                "id": "naltrexone_chronic_pain_improved",
                "type": "yesno"
            },
            {
                "visible": "naltrexone_chronic_pain_improved === false",
                "text": "Is patient currently being treated for OUD or AUD?",
                "id": "naltrexone_treated",
                "type": "choice",
                "choices": [
                    {
                        "text": "OUD"
                    },
                    {
                        "text": "AUD"
                    }
                ]
            },
            {
                "visible": "naltrexone_chronic_pain_improved === true || (naltrexone_chronic_pain_improved === false && (naltrexone_treated == 'OUD' || naltrexone_treated == 'AUD'))",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "naltrexone_chronic_pain_improved === true",
                "style": "pink",
                "text": [
                    "Continue with effective regimen"
                ]
            },
            {
                "visible": "naltrexone_chronic_pain_improved === false && naltrexone_treated == 'OUD'",
                "style": "gray",
                "text": [
                    "For pain that continues to interfere with functional goals, consider transitioning from naltrexone to agonist therapy buprenorphine or methadone.",
                    "",
                    "Methadone must be administered in an opioid treatment program setting."
                ]
            },
            {
                "visible": "naltrexone_chronic_pain_improved === false && naltrexone_treated == 'AUD'",
                "style": "gray",
                "text": [
                    "For pain that continues to interfere with functional goals and management will involve the use of opioid medications, consider transitioning from naltrexone to acamprosate or disulfiram."
                ]
            }
        ],
        "flows": []
    },
    "naltrexone_pain_anticipated": {
        "title": "Pain Management While on Naltrexone",
        "type": "care_plan",
        "tool": "Pain Management While on Naltrexone for Opioid Use Disorder 1-25-2023",
        "content": [
            {
                "visible": "true",
                "style": "gray",
                "text": [
                    "<b>With anticipated surgery</b>:",
                    " - Obtain consent for release of information 42 CFR <a href='https://www.addictiontraining.org/42CFR' style='text-decoration:none;'>&#9432</a> for the surgical/medical team; plan ahead and collaborate.",
                    " - If on XR naltrexone, discontinue at least 4 wks prior to scheduled procedure and bridge with oral naltrexone.",
                    " - Last dose of oral naltrexone to be given 72 hrs prior to procedure.",
                    " - Use multimodal approach to pain management"
                ]
            },
            {
                "visible": "true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "true",
                "text": "Is pain well managed?",
                "id": "naltrexone_pain_anticipated_managed",
                "type": "yesno"
            },
            {
                "visible": "naltrexone_pain_anticipated_managed === true || naltrexone_pain_anticipated_managed === false",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "naltrexone_pain_anticipated_managed === true",
                "style": "pink",
                "text": [
                    "Continue with effective regimen"
                ]
            },
            {
                "visible": "naltrexone_pain_anticipated_managed === false",
                "style": "gray",
                "text": [
                    "<b>For severe acute pain:</b>",
                    " \u2022 If appropriate, patient may be prescribed opioids for pain management.",
                    " \u2022 Once pain has subsided, may resume naltrexone 7-10 days after last opioid use and negative toxicology screen for opioids."
                ]
            }
        ],
        "flows": []
    },
    "naltrexone_pain_unanticipated": {
        "title": "Pain Management While on Naltrexone",
        "type": "care_plan",
        "tool": "Pain Management While on Naltrexone for Opioid Use Disorder 1-25-2023",
        "content": [
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "Efective analgesia should begin with use of non-opioids (if appropriate).",
                    "",
                    "<b>Patients with severe pain may require conscious sedation, or regional or general anesthesia. Patients should be cared for in a setting with cardiopulmonary support.</b>"
                ]
            }
        ],
        "flows": []
    },
    "buprenorphine_pain": {
        "title": "Pain Management While on Buprenorphine",
        "type": "care_plan",
        "tool": "Pain Management While on Buprenorphine for Opioid Use Disorder 08-22_FINAL",
        "content": [
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "Consider splitting patient's maintenance buprenorphine dose to every 6-8 hours."
                ]
            },
            {
                "visible": "pain_type === 'Acute'",
                "style": "pink",
                "text": [
                    "<b>With anticipated surgery</b>:",
                    " - Obtain consent for release of information 42 CFR <a href='https://www.addictiontraining.org/42CFR' style='text-decoration:none;'>&#9432</a> for the surgical/medical team; plan ahead and collaborate.",
                ]
            },
            {
                "visible": "true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "true",
                "text": "Is pain improved?",
                "id": "buprenorphine_pain_improved",
                "type": "yesno"
            },
            {
                "visible": "buprenorphine_pain_improved === true || buprenorphine_pain_improved === false",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "buprenorphine_pain_improved === true",
                "style": "pink",
                "text": [
                    "Continue with split dosing every 6-8 hours."
                ]
            },
            {
                "visible": "buprenorphine_pain_improved === true",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "buprenorphine_pain_improved === true && pain_type === 'Acute'",
                "style": "pink",
                "text": [
                    "<b>Acute Pain:</b> Develop plan with patient when to revert back to previous regimen."
                ]
            },
            {
                "visible": "buprenorphine_pain_improved === true && pain_type === 'Chronic'",
                "style": "pink",
                "text": [
                    "<b>Chronic Pain:</b> May consider maintaining q6-8 hr dosing schedule."
                ]
            },
            {
                "visible": "buprenorphine_pain_improved === false",
                "style": "gray",
                "text": [
                    "In addition to split dosing, combine with non-opioid and adjuvant therapies <a href='https://sitefinitystorage.blob.core.windows.net/sitefinity-production-blobs/docs/default-source/guidelines/npg-jam-supplement.pdf?sfvrsn=a00a52c2_2#page=57' style='text-decoration:none;'>&#9432</a>."
                ]
            },
            {
                "visible": "buprenorphine_pain_improved === false",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "buprenorphine_pain_improved === false",
                "text": "Is pain improved?",
                "id": "buprenorphine_pain_improved_2",
                "type": "yesno"
            },
            {
                "visible": "buprenorphine_pain_improved_2_v && (buprenorphine_pain_improved_2 === true || buprenorphine_pain_improved_2 === false)",
                "style": "down_arrow",
                "text": []
            },
            {
                "visible": "buprenorphine_pain_improved_2_v && buprenorphine_pain_improved_2 === true && pain_type == 'Acute'",
                "style": "pink",
                "text": [
                    "<b>Acute Pain:</b> Continue with q6-8 hr split dosing, non-opioid and adjuvant therapies. Develop plan with patient as to when to revert back to previous regimen."
                ]
            },
            {
                "visible": "buprenorphine_pain_improved_2_v && buprenorphine_pain_improved_2 === true && pain_type == 'Chronic'",
                "style": "pink",
                "text": [
                    "<b>Chronic Pain:</b> Continue with q6-8 hr split dosing, non-opioid and adjuvant therapies."
                ]
            },
            {
                "visible": "buprenorphine_pain_improved_2_v && buprenorphine_pain_improved_2 === false && pain_type == 'Acute'",
                "style": "gray",
                "text": [
                    "Increase dose by 2-4 mg increments up to 24 mg/daily with split q6-8 hr dosing.",
                    "<b style='text-align:center'>          ALSO CONSIDER</b>",
                    "short-acting full agonist in addition to maintenance buprenorphine dose",
                    "<b style='text-align:center'>          AND</b>",
                    "develop plan with patient as to when to revert back to previous regimen.",
                    "If pain is not improved consult with an addiction/pain expert.",
                    "Contact <a href='https://pcssnow.org/mentoring/#ask'>https://pcssnow.org/mentoring/#ask</a>"
                ]
            },
            {
                "visible": "buprenorphine_pain_improved_2_v && buprenorphine_pain_improved_2 === false && pain_type == 'Chronic'",
                "style": "gray",
                "text": [
                    "Increase dose by 2-4 mg increments up to 24 mg/daily with split q6-8 hr dosing, combined with non-opioid and adjuvant therapies. If pain is not improved consult with an addiction/pain expert.",
                    "Contact <a href='https://pcssnow.org/mentoring/#ask'>https://pcssnow.org/mentoring/#ask</a>"
                ]
            }
        ],
        "flows": []
    },
    "dsm_oud": {
        "title": "DSM-5 Criteria for Diagnosis of Opioid Use Disorder",
        "type": "section",
        "eval": [
            "dsm_09 = (dsm_oud_1 ? 1 : 0) + (dsm_oud_2 ? 1 : 0) + (dsm_oud_3 ? 1 : 0) + (dsm_oud_4 ? 1 : 0) + (dsm_oud_5 ? 1 : 0) + (dsm_oud_6 ? 1 : 0) + (dsm_oud_7 ? 1 : 0) + (dsm_oud_8 ? 1 : 0) + (dsm_oud_9 ? 1 : 0)",
            "dsm_011 = (dsm_oud_1 ? 1 : 0) + (dsm_oud_2 ? 1 : 0) + (dsm_oud_3 ? 1 : 0) + (dsm_oud_4 ? 1 : 0) + (dsm_oud_5 ? 1 : 0) + (dsm_oud_6 ? 1 : 0) + (dsm_oud_7 ? 1 : 0) + (dsm_oud_8 ? 1 : 0) + (dsm_oud_9 ? 1 : 0) + (dsm_oud_10 ? 1 : 0) + (dsm_oud_11 ? 1 : 0)",
            "dsm_score = dsm_oud_supervision == true ? dsm_09 : dsm_011",
            "dsm_total = dsm_oud_supervision == true ? 9 : 11"
        ],
        "content": [
            {
                "visible": "true",
                "id": "dsm_oud_1",
                "text": "Opioids are often taken in larger amounts or over a longer period than was intended.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_2",
                "text": "There is a persistent desire or unsuccessful efforts to cut down or control opioid use.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_3",
                "text": "A great deal of time is spent in activities necessary to obtain the opioid, use the opioid, or recover from its effects.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_4",
                "text": "Craving, or a strong desire or urge to use opioids.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_5",
                "text": "Recurrent opioid use resulting in a failure to fulfill major role obligations at work, school, or home.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_6",
                "text": "Continued opioid use, despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of opioids.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_7",
                "text": "Important social, occupational, or recreational activities are given up or reduced because of opioid use.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_8",
                "text": "Recurrent opioid use in situations in which it is physically hazardous.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_9",
                "text": "Continued opioid use, despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by the substance.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_supervision",
                "text": "Is the patient currently taking prescribed opioids solely under appropriate medical supervision?",
                "type": "yesno"
            },

            {
                "visible": "true",
                "id": "dsm_oud_10",
                "text": "Tolerance, as defined by either of the following:<br/>&nbsp;a. Need for markedly increased amounts of opioids to achieve intoxication or desired effect.<br/>&nbsp;b. Markedly diminished effect with continued use of the same amount of opioid.",
                "type": "yesno"
            },
            {
                "visible": "true",
                "id": "dsm_oud_11",
                "text": "Withdrawal, as manifested by either of the following:<br/>&nbsp;a. The characteristic opioid withdrawal syndrome (refer to Criteria A and B of the criteria set for opioid withdrawal, pp. 547-548 of DSM-5).<br/>&nbsp;b. Opioids (or a closely related substance) are taken to relieve or avoid withdrawal symptoms.",
                "type": "yesno"
            },
            {
                "visible": "false",
                "text": [
                    "<small>* Note: This criterion is not considered to be met for those individuals taking opioids solely under appropriate medical supervision.</small>"
                ]
            },
            {
                "style": "yellow",
                "visible": "dsm_score < 2",
                "align": "center",
                "calc": "dsm_score + '/' + dsm_total",
                "text": [
                    "<big><b>Symptoms: {value}.</b></big>",
                    "",
                    "<big><b>Patient does not meet the criteria for diagnosis of a OUD.</b></big>"
                ]
            },
            {
                "style": "yellow",
                "visible": "dsm_score >= 2 && dsm_score <= 3",
                "align": "center",
                "calc": "dsm_score + '/' + dsm_total",
                "text": [
                    "<big><b>Symptoms: {value}.</b></big>",
                    "",
                    "<big><b>Mild: Presence of 2-3 symptoms.</b></big>"
                ]
            },
            {
                "style": "yellow",
                "visible": "dsm_score >= 4 && dsm_score <= 5",
                "align": "center",
                "calc": "dsm_score + '/' + dsm_total",
                "text": [
                    "<big><b>Symptoms: {value}.</b></big>",
                    "",
                    "<big><b>Moderate: Presence of 4-5 symptoms.</b></big>"
                ]
            },
            {
                "style": "yellow",
                "visible": "dsm_score >= 6",
                "align": "center",
                "calc": "dsm_score + '/' + dsm_total",
                "text": [
                    "<big><b>Symptoms: {value}.</b></big>",
                    "",
                    "<big><b>Severe: Presence of 6 or more symptoms.</b></big>"
                ]
            },
            {
                "visible": "dsm_oud_supervision == true",
                "text": [
                    "Differentiation between opioid tolerance and opioid use disorder can be challenging. For expert guidance, contact <a href='https://nccc.ucsf.edu/clinical-resources/substance-use-resources/'>National Clinician Consultation Center (NCCC)</a> resource providing free and confidential consultation on substance use evaluation and management for clinicians across the U.S. Hours: Monday-Friday, 9 AM - 8 PM ET.</a>"
                ]
            },
            {
                "style": "plain",
                "visible": "true",
                "text": [
                    "<small>Reprinted with permission from the Diagnostic and Statistical Manual of Mental Disorders, Fifth Edition®. Copyright ©2013 American Psychiatric Association. All Rights Reserved.<br><br>Unless authorized in writing by the APA, no part may be reproduced or used in a manner inconsistent with the APA’s copyright. This prohibition applies to unauthorized uses or reproductions in any form.<br><br>The American Psychiatric Association is not affiliated with and is not endorsing this product.</small>"
                ]
            }
        ]
    },
    "cows_tool": {
        "title": "Clinical Opiate Withdrawal Scale (COWS)",
        "type": "section",
        "content": [
            {
                "visible": "true",
                "id": "cows_rpr",
                "text": "Resting pulse rate:\n<i>Measured after patient is sitting/lying for one minute.</i>",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "Pulse rate 80 or below (0)",
                        "value": 0
                    },
                    {
                        "text": "Pulse rate 81-100 (1)",
                        "value": 1
                    },
                    {
                        "text": "Pulse rate 101-120 (2)",
                        "value": 2
                    },
                    {
                        "text": "Pulse rate greater than 120 (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_sweating",
                "text": "Sweating:\n<i>Over past ½ hour not accounted for by room temperature or patient activity.</i>",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "No report of chills of flushing (0)",
                        "value": 0
                    },
                    {
                        "text": "One subjective report of chills or flushing (1)",
                        "value": 1
                    },
                    {
                        "text": "Flushed or observable moistness on face (2)",
                        "value": 2
                    },
                    {
                        "text": "Beads of sweat on brow or face (3)",
                        "value": 3
                    },
                    {
                        "text": "Sweat streaming off face (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_restlessness",
                "text": "Restlessness:\n<i>Observation during assessment.</i>",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "Able to sit still (0)",
                        "value": 0
                    },
                    {
                        "text": "Report difficulty sitting still, but is able to do so (1)",
                        "value": 1
                    },
                    {
                        "text": "Frequent shifting or extraneous movements of legs/arms (3)",
                        "value": 3
                    },
                    {
                        "text": "Unable to sit still for more than a few seconds (5)",
                        "value": 5
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_pupil",
                "text": "Pupil Size",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "Pupils pinned or normal size for room light (0)",
                        "value": 0
                    },
                    {
                        "text": "Pupils possibly larger than normal for room light (1)",
                        "value": 1
                    },
                    {
                        "text": "Pupils moderately dilated (2)",
                        "value": 2
                    },
                    {
                        "text": "Pupils so dilated that only rim of the iris is visible (5)",
                        "value": 5
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_aches",
                "text": "Bone or Joint aches:\n<i>If patient was having pains previously, only the additional component attributed to opiate withdrawal is scored.</i>",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "Not present (0)",
                        "value": 0
                    },
                    {
                        "text": "Mild diffuse discomfort (1)",
                        "value": 1
                    },
                    {
                        "text": "Patient reports severe diffuse aching of joints/muscles (2)",
                        "value": 2
                    },
                    {
                        "text": "Patient is rubbing joints or muscles and is unable to sit still because of discomfort (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_nose",
                "text": "Runny nose or tearing:\n<i>Not accounted for by cold symptoms or allergies.</i>",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "Not present (0)",
                        "value": 0
                    },
                    {
                        "text": "Nasal stuffiness or unusually moist eyes (1)",
                        "value": 1
                    },
                    {
                        "text": "Nose running or tearing (2)",
                        "value": 2
                    },
                    {
                        "text": "Nose constantly running or tears treaming down cheeks (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_gi",
                "text": "GI Upset:\n<i>Over last ½ hour</i>",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "No GI symptoms (0)",
                        "value": 0
                    },
                    {
                        "text": "Stomach cramps (1)",
                        "value": 1
                    },
                    {
                        "text": "Nausea or loose stools (2)",
                        "value": 2
                    },
                    {
                        "text": "Vomiting or diarrhea (3)",
                        "value": 3
                    },
                    {
                        "text": "Multiple episodes of diarrhea or vomiting (5)",
                        "value": 5
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_tremor",
                "text": "Tremor:\n<i>Observation of outstretched hands</i>",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "No tremor (0)",
                        "value": 0
                    },
                    {
                        "text": "Tremor can be felt, but not observed (1)",
                        "value": 1
                    },
                    {
                        "text": "Slight tremor observable (2)",
                        "value": 2
                    },
                    {
                        "text": "Gross tremor or muscole twitching (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_yawning",
                "text": "Yawning:\n<i>Observation during assessment</i>",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "No yawning (0)",
                        "value": 0
                    },
                    {
                        "text": "Yawning once or twice during assessment (1)",
                        "value": 1
                    },
                    {
                        "text": "Yawning three or more times during assessment (2)",
                        "value": 2
                    },
                    {
                        "text": "Yawning several times/minute (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_anxiety",
                "text": "Anxiety or Irritability",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "None (0)",
                        "value": 0
                    },
                    {
                        "text": "Patient reports increasing irritability or anxiousness (1)",
                        "value": 1
                    },
                    {
                        "text": "Patient obviously irritable, anxious (2)",
                        "value": 2
                    },
                    {
                        "text": "Patient so irritable or anxious that participation in the assessment is difficult (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "cows_skin",
                "text": "Gooseflesh skin",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "Skin is smooth (0)",
                        "value": 0
                    },
                    {
                        "text": "Piloerection of skin can be felt or hairs standing up on arms (3)",
                        "value": 3
                    },
                    {
                        "text": "Prominent piloerection (5)",
                        "value": 5
                    }
                ]
            },
            {
                "align": "center",
                "style": "yellow",
                "calc": "(parseInt(cows_rpr) + parseInt(cows_sweating) + parseInt(cows_restlessness) + parseInt(cows_pupil) + parseInt(cows_aches) + parseInt(cows_nose) + parseInt(cows_gi) + parseInt(cows_tremor) + parseInt(cows_yawning) + parseInt(cows_anxiety) + parseInt(cows_skin))",
                "visible": "value < 5 && cows_rpr !== '' && cows_sweating !== '' && cows_restlessness !== '' && cows_pupil !== '' && cows_aches !== '' && cows_nose !== '' && cows_gi !== '' && cows_tremor !== '' && cows_yawning !== '' && cows_anxiety !== '' && cows_skin !== ''",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<big><b>No active withdrawal range: 0-4.</b></big>"
                ]
            },
            {
                "align": "center",
                "style": "yellow",
                "calc": "(parseInt(cows_rpr) + parseInt(cows_sweating) + parseInt(cows_restlessness) + parseInt(cows_pupil) + parseInt(cows_aches) + parseInt(cows_nose) + parseInt(cows_gi) + parseInt(cows_tremor) + parseInt(cows_yawning) + parseInt(cows_anxiety) + parseInt(cows_skin))",
                "visible": "value >= 5 && value < 13 && cows_rpr !== '' && cows_sweating !== '' && cows_restlessness !== '' && cows_pupil !== '' && cows_aches !== '' && cows_nose !== '' && cows_gi !== '' && cows_tremor !== '' && cows_yawning !== '' && cows_anxiety !== '' && cows_skin !== ''",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<big><b>Mild withdrawal range: 5-12.</b></big>"
                ]
            },
            {
                "align": "center",
                "style": "yellow",
                "calc": "(parseInt(cows_rpr) + parseInt(cows_sweating) + parseInt(cows_restlessness) + parseInt(cows_pupil) + parseInt(cows_aches) + parseInt(cows_nose) + parseInt(cows_gi) + parseInt(cows_tremor) + parseInt(cows_yawning) + parseInt(cows_anxiety) + parseInt(cows_skin))",
                "visible": "value >= 13 && value <= 24 && cows_rpr !== '' && cows_sweating !== '' && cows_restlessness !== '' && cows_pupil !== '' && cows_aches !== '' && cows_nose !== '' && cows_gi !== '' && cows_tremor !== '' && cows_yawning !== '' && cows_anxiety !== '' && cows_skin !== ''",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<big><b>Moderate withdrawal range: 13-24.</b></big>"
                ]
            },
            {
                "align": "center",
                "style": "yellow",
                "calc": "(parseInt(cows_rpr) + parseInt(cows_sweating) + parseInt(cows_restlessness) + parseInt(cows_pupil) + parseInt(cows_aches) + parseInt(cows_nose) + parseInt(cows_gi) + parseInt(cows_tremor) + parseInt(cows_yawning) + parseInt(cows_anxiety) + parseInt(cows_skin))",
                "visible": "value >= 25 && value <= 36 && cows_rpr !== '' && cows_sweating !== '' && cows_restlessness !== '' && cows_pupil !== '' && cows_aches !== '' && cows_nose !== '' && cows_gi !== '' && cows_tremor !== '' && cows_yawning !== '' && cows_anxiety !== '' && cows_skin !== ''",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<big><b>Moderately severe withdrawal range: 25-36.</b></big>"
                ]
            },
            {
                "align": "center",
                "style": "yellow",
                "calc": "(parseInt(cows_rpr) + parseInt(cows_sweating) + parseInt(cows_restlessness) + parseInt(cows_pupil) + parseInt(cows_aches) + parseInt(cows_nose) + parseInt(cows_gi) + parseInt(cows_tremor) + parseInt(cows_yawning) + parseInt(cows_anxiety) + parseInt(cows_skin))",
                "visible": "value > 36 && cows_rpr !== '' && cows_sweating !== '' && cows_restlessness !== '' && cows_pupil !== '' && cows_aches !== '' && cows_nose !== '' && cows_gi !== '' && cows_tremor !== '' && cows_yawning !== '' && cows_anxiety !== '' && cows_skin !== ''",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<big><b>Severe withdrawal range: Greater than 36.</b></big>"
                ]
            },
            {
                "style": "plain",
                "visible": "true",
                "text": [
                    "<small>The Clinical Opiate Withdrawal Scale (COWS) was developed by Wesson and Ling: Wesson, D. R., & Ling, W. (2003). The Clinical Opiate Withdrawal Scale (COWS). Journal of psychoactive drugs, 35(2), 253–259.</small>"
                ]
            }
        ]
    },
    "audit_c": {
        "title": "AUDIT-C for Alcohol Use",
        "type": "section",
        "content": [
            {
                "visible": "true",
                "id": "audit_often",
                "text": "How often did you have a drink containing alcohol in the past year?",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "Never (0)",
                        "value": 0
                    },
                    {
                        "text": "Monthly or less (1)",
                        "value": 1
                    },
                    {
                        "text": "Two to four times a month (2)",
                        "value": 2
                    },
                    {
                        "text": "Two to three times per week (3)",
                        "value": 3
                    },
                    {
                        "text": "Four or more times a week (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "audit_perday",
                "text": "How many drinks containing alcohol did you have on a typical day when you were drinking in the past year?",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "1 or 2 drinks (0)",
                        "value": 0
                    },
                    {
                        "text": "3 or 4 (1)",
                        "value": 1
                    },
                    {
                        "text": "5 or 6 (2)",
                        "value": 2
                    },
                    {
                        "text": "7 to 9 (3)",
                        "value": 3
                    },
                    {
                        "text": "10 or more (4)",
                        "value": 4
                    }
                ]
            },
            {
                "visible": "true",
                "id": "audit_peroccasion",
                "text": "How often did you have six or more drinks on one occasion in the past year?",
                "type": "dchoice",
                "choices": [
                    {
                        "text": "Never (0)",
                        "value": 0
                    },
                    {
                        "text": "Less than monthly (1)",
                        "value": 1
                    },
                    {
                        "text": "Monthly (2)",
                        "value": 2
                    },
                    {
                        "text": "Weekly (3)",
                        "value": 3
                    },
                    {
                        "text": "Daily or almost daily (4)",
                        "value": 4
                    }
                ]
            },
            {
                "calc": "(parseInt(audit_often) + parseInt(audit_perday) + parseInt(audit_peroccasion))",
                "style": "yellow",
                "visible": "value < 3 && audit_often !== '' && audit_perday !== '' && audit_peroccasion !== ''",
                "align": "center",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<b>Scores &lt;3 are consistent with normal alcohol consumption.</b>"
                ]
            },
            {
                "calc": "(parseInt(audit_often) + parseInt(audit_perday) + parseInt(audit_peroccasion))",
                "style": "yellow",
                "visible": "value == 3 && audit_often !== '' && audit_perday !== '' && audit_peroccasion !== ''",
                "align": "center",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<b>For females: Scores ≥3 are consistent with alcohol misuse. For males: Normal alcohol consumption.</b>"
                ]
            },
            {
                "calc": "(parseInt(audit_often) + parseInt(audit_perday) + parseInt(audit_peroccasion))",
                "style": "yellow",
                "visible": "audit_often == 4 && audit_perday == 0 && audit_peroccasion == 0 && audit_often !== '' && audit_perday !== '' && audit_peroccasion !== ''",
                "align": "center",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<b>For females: Scores ≥3 are consistent with alcohol misuse. For males: Scores ≥4 are consistent with alcohol misuse.</b>",
                    "<b>When points are only from Question 1, patients are often drinking below the AUDIT-C cutoff; to confirm accuracy, review patient’s alcohol intake over past months.</b>"
                ]
            },
            {
                "calc": "(parseInt(audit_often) + parseInt(audit_perday) + parseInt(audit_peroccasion))",
                "style": "yellow",
                "visible": "value == 4 && (audit_perday != 0 || audit_peroccasion != 0) && audit_often !== '' && audit_perday !== '' && audit_peroccasion !== ''",
                "align": "center",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<b>For females: Scores ≥3 are consistent with alcohol misuse. For males: Scores ≥4 are consistent with alcohol misuse.</b>"
                ]
            },
            {
                "calc": "(parseInt(audit_often) + parseInt(audit_perday) + parseInt(audit_peroccasion))",
                "style": "yellow",
                "visible": "value >= 5 && audit_often !== '' && audit_perday !== '' && audit_peroccasion !== ''",
                "align": "center",
                "text": [
                    "<big><b>Total Score: {value}.</b></big>",
                    "",
                    "<b>Scores ≥5 are consistent with alcohol misuse and possible liver damage.</b>"
                ]
            },
            {
                "style": "plain",
                "visible": "true",
                "text": [
                    "<small>The AUDIT Alcohol Consumption Questions (AUDIT-C) for the diagnosis of alcohol use disorder were developed by Bush et al.: Bush, K., Kivlahan, D. R., McDonell, M. B., Fihn, S. D., & Bradley, K. A. (1998). The AUDIT alcohol consumption questions (AUDIT-C): an effective brief screening test for problem drinking. Archives of internal medicine, 158(16), 1789-1795.</small>"
                ]
            }
        ]
    },
    "medications_assist": {
        "title": "Medications to Assist in the Management of Opioid Withdrawal Symptoms",
        "type": "care_plan",
        "content": [
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "<b>Anxiety:</b>",
                    "\u2022 Antihistamines",
                    "\u2022 Alpha2-Adrenergic Agonists"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "<b>Insomnia:</b>",
                    "\u2022 Sedating antidepressants",
                    "\u2022 Antihistamines"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "<b>Musculoskeletal Pain:</b>",
                    "\u2022 NSAIDs",
                    "\u2022 Acetaminophen",
                    "\u2022 Heatpacks",
                    "\u2022 Topical analgesics"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "<b>Gastrointestinal Distress:</b>",
                    "\u2022 Antiemetics",
                    "\u2022 Antispasmodics",
                    "\u2022 Antidiarheals",
                    "\u2022 Oral hydration"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "<b>Restless legs:</b>",
                    "\u2022 Muscle relaxants",
                    "\u2022 Dopamine Agonists"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "<b>Rhinorhea:</b>",
                    "\u2022 Antihistamines"
                ]
            }
        ]
    },
    "references": {
        "title": "Reference for BMC Grayken Center for Addiction TTA",
        "type": "care_plan",
        "content": [
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "American Society of Addiction Medicine (ASAM)",
                    "",
                    "<a href='https://sitefinitystorage.blob.core.windows.net/sitefinity-production-blobs/docs/default-source/guidelines/npg-jam-supplement.pdf?sfvrsn=a00a52c2_2'>https://sitefinitystorage.blob.core.windows.net/sitefinity-production-blobs/docs/default-source/guidelines/npg-jam-supplement.pdf?sfvrsn=a00a52c2_2</a>"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "CDC Guidelines for prescribing opioids for Chronic Pain",
                    "",
                    "<a href='https://www.cdc.gov/mmwr/volumes/65/rr/rr6501e1.htm'>https://www.cdc.gov/mmwr/volumes/65/rr/rr6501e1.htm</a>"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "Department of Veterans Affairs (VA) VA/DoD Clinical Practice Guidelines for the Management of Substance Use Disorders. Version 4.0-2021",
                    "",
                    "<a href='https://www.healthquality.va.gov/guidelines/MH/sud/VADoDSUDCPG.pdf'>https://www.healthquality.va.gov/guidelines/MH/sud/VADoDSUDCPG.pdf</a>"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "Substance Abuse and Mental Health Administration Clinical Use of Extended-Release Injectable Naltrexone.",
                    "",
                    "<a href='https://store.samhsa.gov/sites/default/files/d7/priv/sma14-4892r.pdf'>https://store.samhsa.gov/sites/default/files/d7/priv/sma14-4892r.pdf</a>"
                ]
            },
            {
                "visible": "true",
                "style": "pink",
                "text": [
                    "Substance Abuse and Mental Health Services Administration. Medications for Opioid Use Disorder. Treatment Improvement Protocol (TIP) Series 63 Publication No. PEP21-02-01-002. Rockville, MD: Substance Abuse and Mental Health Services Administration, 2021.",
                    "",
                    "<a href='https://store.samhsa.gov/sites/default/files/SAMHSA_Digital_Download/PEP21-02-01-002.pdf'>https://store.samhsa.gov/sites/default/files/SAMHSA_Digital_Download/PEP21-02-01-002.pdf</a>"
                ]
            }
        ]
    },
    "handout_english": {
        "title": "Buprenorphine Initiation Guide - English",
        "type": "section",
        "figure": "English V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL",
        "figure_ar": "landscape",
        "content": [
            {
                "visible": "true",
                "id": "send_sms",
                "text": "Securely text handout with SMS",
                "figure": "English V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL",
                "type": "button"
            }
        ]
    },
    "handout_spanish": {
        "title": "Buprenorphine Initiation Guide - Spanish",
        "type": "section",
        "figure": "Spanish V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL",
        "figure_ar": "landscape",
        "content": [
            {
                "visible": "true",
                "id": "send_sms",
                "text": "Securely text handout with SMS",
                "figure": "Spanish V Grayken Colors 121_118_Home_Buprenorphine_Initiation_NIDA_ 09-2022_FINAL",
                "type": "button"
            }
        ]
    }
};

export function getAllDataInSection(section) {
    return flowChartData[section];
}

export function getAllPagesInSection(section) {
    if (section) {
        return getAllDataInSection(section).pages.map((page) => {
            page.id = section;
            return page;
        });
    }
    return null;
}

export function getAllQuestionsInSection(section) {
    if (getAllDataInSection(section).pages) {
        var acontents = getAllDataInSection(section).pages.map((page) => page.content);
        var contents = Array.prototype.concat.apply([], acontents);
        return contents.filter( a => a.type);
    } else {
        var contents = getAllDataInSection(section).content;
        return contents.filter( a => a.type);
    }
}

export function getAllQuestionsInPage(page) {
    const questions = page.content.filter( a => a.type);
    return questions;
}

export function getAllPostContentInSection(section) {
    if (getAllDataInSection(section).pages) {
        var acontents = getAllDataInSection(section).pages.map((page) => page.content);
        var contents = Array.prototype.concat.apply([], acontents);
        return contents.filter( a => !a.type);
    } else {
        var contents = getAllDataInSection(section).content;
        return contents.filter( a => !a.type);
    }
}

export function getAllPostContentInPage(page) {
    const content = page.content.filter( a => !a.type);
    return content;
}

export function getAllCategoriesInSection(section) {
    const categories = {};
    getAllQuestionsInSection(section).forEach((question) => {
        if (question.type === "yesno") {
            categories[question.id] = null;
        } else {
            categories[question.id] = "";
        }
    });
    return categories;
}

export default flowChartData;
